// Resolves a calendar event's color based on customer-defined event categories.
// Categories are { keyword, color } pairs stored on customer.featureFlags.eventCategories.
// When an event title or body contains a keyword (case-insensitive), the category color
// wins over event.backgroundColor; otherwise we fall back to the stored backgroundColor.
// A category keyword may hold several words separated by commas ("Operasjon, Anestesi");
// each word matches on its own, and the longest matching word wins across categories.

export function matchEventCategory(text, categories) {
    if (!text || !Array.isArray(categories) || categories.length === 0) return null;
    const lower = String(text).toLowerCase();
    const terms = [];
    categories
        .filter(c => c && c.keyword && c.color)
        .forEach(category => {
            String(category.keyword).split(',')
                .map(word => word.trim().toLowerCase())
                .filter(Boolean)
                .forEach(word => terms.push({ word, category }));
        });
    terms.sort((a, b) => b.word.length - a.word.length);
    const match = terms.find(t => lower.includes(t.word));
    return match ? match.category : null;
}

export function resolveEventColor(event, categories) {
    if (!event) return null;
    const haystack = [event.title, event.body].filter(Boolean).join(' \n ');
    const match = matchEventCategory(haystack, categories);
    if (match) return match.color;
    return event.backgroundColor ? event.backgroundColor : null;
}
